import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import ListValue from "./controls/ListValue";
import LongTextValue from "./controls/LongTextValue";
import MeasureValue from "./controls/MeasureValue";
import TextValue from "./controls/TextValue";
import Col from "./layout/Col";
import Grid from "./layout/Grid";
import Row from "./layout/Row";

export function FuenteEfluenteLiquidoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value?.map((fuenteEfluenteLiquido, index) => (
        <ListGroupObjectItem
          key={fuenteEfluenteLiquido.orden}
          index={index}
          indexLabel={t("fuenteEfluenteLiquido.orden")}
          value={fuenteEfluenteLiquido}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document.getElementById("fuentesEfluentesLiquidos").scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <TextValue
                    label={t("fuenteEfluenteLiquido.nombre")}
                    value={value.nombre}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LongTextValue
                    label={t("fuenteEfluenteLiquido.destino")}
                    value={value.destino}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ListValue
                    label={t("fuenteEfluenteLiquido.operacionesUnitarias")}
                    value={value.operacionesUnitarias}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <MeasureValue
                    label={t("fuenteEfluenteLiquido.caudalMedio")}
                    value={value.caudalMedio}
                  />
                </Col>
              </Row>
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
